<script>
	import CustomInput from "src/components/CustomInput/CustomInput.svelte";
	import { splitCamelCaseAndCapitalize } from "src/utils/misc";
	import { damageAttributionOptions } from "src/utils/options";
	import { Col, Row } from "@sveltestrap/sveltestrap";

	export let attribution;
	export let damageCause;
	export let damageCauseType;
	export let staffName;
	export let staffContact;
	export let thirdPartyName;
	export let thirdPartyContact;
	export let form;
	export let bidError = "";
</script>

<Row class="mb-4">
	<Col xs={5}>
		<Row>
			<Col>
				<label for="attribution" class="d-block">
					<span>
						Attributed to<span class="text-danger">*</span>
					</span>
				</label>
			</Col>
		</Row>
		<Row>
			{#each damageAttributionOptions as { value, label }}
				<Col>
					<input
						type="radio"
						name="attribution"
						id={value}
						{value}
						on:change={(e) => {
							$attribution.value = e.target.value;
						}}
						checked={value === $attribution.value}
					/>
					<label for={value}
						>{splitCamelCaseAndCapitalize(label)}</label
					>
				</Col>
			{/each}
		</Row>
	</Col>
</Row>
{#if $attribution?.value === "User"}
	<!-- User -->
	<Row class="mb-4">
		<Col xs={4}>
			<Row>
				<Col>
					<label for="damageCause" class="d-block">
						<span>
							Booking ID<span class="text-danger">*</span>
						</span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col>
					<CustomInput
						id={`damageCause`}
						type="text"
						bind:value={$damageCause.value}
						placeholder="Enter BID that caused the damage"
						error={$form.hasError("damageCause.required") ||
							bidError}
						errorText={$form.hasError("damageCause.required")
							? "Booking ID is required"
							: bidError
								? bidError
								: ""}
					/>
				</Col>
			</Row>
		</Col>
	</Row>
{/if}
{#if $attribution?.value === "Staff"}
	<!-- Staff -->
	<Row class="mb-4">
		<Col xs={4}>
			<Row>
				<Col>
					<label for="zendeskTicketId" class="d-block">
						<span>
							Staff Name
							<span class="text-danger">*</span>
						</span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col>
					<CustomInput
						type="text"
						bind:value={$staffName.value}
						placeholder="Enter name of staff"
						error={$form.hasError("staffName.required")}
						errorText={$form.hasError("staffName.required")
							? "Staff name is required"
							: ""}
						maxlength={100}
					/>
				</Col>
			</Row>
		</Col>
		<Col xs={4}>
			<Row>
				<Col>
					<label for="zendeskTicketId" class="d-block">
						<span>
							Staff Contact No <span class="text-danger">*</span
							></span
						>
					</label>
				</Col>
			</Row>
			<Row>
				<Col>
					<CustomInput
						type="number"
						bind:value={$staffContact.value}
						placeholder="Enter mobile number"
						phoneNoPrefix={true}
						classes="phoneNo-prefix"
						error={$form.hasError("staffContact.required")}
						errorText={$form.hasError("staffContact.required")
							? "Staff contact no is required"
							: ""}
					/>
				</Col>
			</Row>
		</Col>
	</Row>
{/if}
{#if $attribution?.value === "ThirdParty"}
	<!-- Third Party -->
	<Row class="mb-4">
		<Col xs={4}>
			<Row>
				<Col>
					<label for="thirdPartyName" class="d-block">
						<span>
							Third Party Name
							<span class="text-danger">*</span>
						</span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col>
					<CustomInput
						type="text"
						bind:value={$thirdPartyName.value}
						placeholder="Enter name of third party"
						error={$form.hasError("thirdPartyName.required")}
						errorText={$form.hasError("thirdPartyName.required")
							? "Third party name is required"
							: ""}
						maxlength={100}
					/>
				</Col>
			</Row>
		</Col>
		<Col xs={4}>
			<Row>
				<Col>
					<label for="thirdPartyContact" class="d-block">
						<span>
							Third Party Contact No <span class="text-danger"
								>*</span
							></span
						>
					</label>
				</Col>
			</Row>
			<Row>
				<Col>
					<CustomInput
						type="number"
						bind:value={$thirdPartyContact.value}
						placeholder="Enter mobile number"
						classes="phoneNo-prefix"
						phoneNoPrefix={true}
						error={$form.hasError("thirdPartyContact.required")}
						errorText={$form.hasError("thirdPartyContact.required")
							? "Third party contact no is required"
							: ""}
					/>
				</Col>
			</Row>
		</Col>
	</Row>
{/if}
